module.exports = __webpack_public_path__ + "static/pionoise-cc56b52ceb4245fbe21bf36251ec1d45.png";